module.exports = __webpack_public_path__ + "img/q.52ebdd47.png";